// Lodash
import _toLower from 'lodash/toLower';
import _includes from 'lodash/includes';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
export var checkCaseInsensitiveSubstringMatch = function checkCaseInsensitiveSubstringMatch(stringToMatch, searchText) {
  var caseInsensitiveString = _toLower(stringToMatch);
  var caseInsensitiveSearchText = _toLower(searchText);
  var caseInsensitiveSubstringMatchSuccess = _includes(caseInsensitiveString, caseInsensitiveSearchText);
  return caseInsensitiveSubstringMatchSuccess;
};
export var defaultFilterOption = function defaultFilterOption() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var searchText = arguments.length > 1 ? arguments[1] : undefined;
  var optionLabel = option.label;
  var isSubstringMatched = checkCaseInsensitiveSubstringMatch(optionLabel, searchText);
  return isSubstringMatched;
};